import { FormControl, FormGroup } from '@angular/forms';
import { DescricaoAtributo } from '../functions/DescricaoAtributo';
import { RepresentanteLegal } from './RepresentanteLegal';

@DescricaoAtributo({
  nome: 'Nome do Usuário',
  email: 'Email do Usuário',
  cpf: 'CPF do Requerente',
  dataNascimento: 'Data de Nascimento do Requerente',
  descricaoLgpd: 'Descrição da Lei Geral de Proteção de Dados - LGPD',
  requerente: 'Requerente da Informação',
  representanteLegal: 'Representante Legal',
  demanda: 'Tipo de Demanda',
  retorno: 'Tipo de Retorno',
  numeroProcessoSEI: 'Número do Processo SEI',
  emailRetorno: 'E-mail para Retorno',
  endereco: 'Endereço para Retorno',
  cep: 'CEP para Retorno',
  // identificacaoTitular: 'Documento de identificação oficial com foto',
  // fotoRequerente: 'Foto do(a) requerente com documento de identificação próximo ao rosto',
  // documentoLegal: 'Procuração lavrada em cartório ou outro documento legal equivalente',
  // listaClassificacao: 'Assunto(s)',
  // assunto: 'Assunto',
})
export class LgpdVO {
  id: number;
  username: FormControl | string = '';
  dataHoraAbertura: Date;
  nome: FormControl | string;
  email: FormControl | string;
  cpf: FormControl | string;
  dataNascimento: FormControl | string;
  descricaoLgpd: FormControl | string;
  requerente: FormControl | string;
  representanteLegal: FormGroup | RepresentanteLegal;
  demanda: FormControl | string;
  retorno: FormControl | string;
  emailRetorno: FormControl | string;
  endereco: FormControl | string;
  cep: FormControl | string;
  numeroProcessoSEI: FormControl | number;
  // listaClassificacao: FormControl | Classificacao[];
  // listaClassificacaoCompleta: Classificacao[];

  files: any[] = [];
  identificacaoTitular: FormControl | any[] = [];
  fotoRequerente: FormControl | any[] = [];
  documentoLegal: FormControl | any[] = [];

  demandaRecebida: FormControl | string = '';

  // assunto: FormControl | AssuntoDTO;
  // assuntos: AssuntoDTO[];
}
